import React, { useMemo, useRef, useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { DateConvert } from "../../helper/DateConvert";
import { BaseUrl } from "../../helper/BaseUrl";
import Icons from "../../myIcon/Icons";
import { getMediaUrl } from '../../helper/mediaUrl';

const truncateWords = (text, wordLimit) => {
  if (!text) return "";
  const words = text.trim().split(/\s+/);
  return words.length > wordLimit
    ? words.slice(0, wordLimit).join(" ") + "..."
    : text;
};

export default function BlogFilter({ allData = [] }) {
  const [searchTerm, setSearchTerm] = useState("");
  const [visibleCount, setVisibleCount] = useState(5);
  const [isLoadMore, setIsLoadMore] = useState(true);
  const [open, setOpen] = useState(false);
  const [selected, setSelected] = useState("All Location");
  const filterRef = useRef(null);

  /* ----------------------------------
     CREATE UNIQUE LOCATIONs
  -----------------------------------*/
  const locations = useMemo(() => {
    const apiLocations = allData
      .map(item => item?.location_name?.trim())
      .filter(Boolean);

    return ["All Location", ...new Set(apiLocations)];
  }, [allData]);

  /* ----------------------------------
     CLOSE DROPDOWN ON OUTSIDE CLICK
  -----------------------------------*/
  useEffect(() => {
    const handleClickOutside = (e) => {
      if (filterRef.current && !filterRef.current.contains(e.target)) {
        setOpen(false);
      }
    };
    document.addEventListener("click", handleClickOutside);
    return () => document.removeEventListener("click", handleClickOutside);
  }, []);

  /* ----------------------------------
     CLOSE DROPDOWN ON ESC
  -----------------------------------*/
  useEffect(() => {
    const handleEsc = (e) => {
      if (e.key === "Escape") setOpen(false);
    };
    document.addEventListener("keyup", handleEsc);
    return () => document.removeEventListener("keyup", handleEsc);
  }, []);

  /* ----------------------------------
     FILTER LOGIC (FIXED)
  -----------------------------------*/
  const filteredData = useMemo(() => {
    return allData.filter((item) => {
      const title = item?.title?.toLowerCase().trim() || "";
      const location = item?.location_name?.toLowerCase().trim() || "";

      const matchSearch = title.includes(searchTerm.toLowerCase()) || location.includes(searchTerm.toLowerCase());
      const matchLocation =
        selected === "All Location"
          ? true
          : location === selected.toLowerCase().trim();

      return matchSearch && matchLocation;
    });
  }, [allData, searchTerm, selected]);

  const displayData =
  searchTerm.trim() === "" && selected === "All Location"
    ? filteredData.slice(1, visibleCount)
    : filteredData.slice(0, visibleCount); 


  //---- lazy load
    useEffect(() => {
      setVisibleCount(5);
    }, [allData]);
  
    useEffect(() => {
      const handleScroll = () => {
        if (
          window.innerHeight + window.scrollY >= document.body.offsetHeight - 300
        ) {
          setVisibleCount((prev) => prev + 4);
        }
      };
  
      window.addEventListener("scroll", handleScroll);
  
      return () => window.removeEventListener("scroll", handleScroll);
    }, []);


  /* ----------------------------------
     RESET ON FILTER CHANGE
  -----------------------------------*/
  useEffect(() => {
    setVisibleCount(7);
    setIsLoadMore(true);
  }, [searchTerm, selected]);


  return (
    <div className="blog-listing">
      <div className="container">
        <div className="filter-section">
          <div className="row">
            <div className="col-md-6">
              <div className="blog-search">
                <form className="searchbox-container" onSubmit={(e) => e.preventDefault()} >
                  <input type="search" className="searchbox form-control" placeholder="Search here" name="search" onChange={(e) => setSearchTerm(e.target.value)} />
                  <button type="submit" className="search-button">
                    <Icons name="search" />
                  </button>
                </form>
              </div>
            </div>
            <div className="col-md-6">
              <div className="room-type">
                <div className={`bloglist-filter ${open ? "open" : ""}`} ref={filterRef} >
                  <div className="caption-filter" onClick={() => setOpen(!open)} >
                    {selected}   <Icons name="arrowDown" />   </div>
                  {open && (
                    <div className="list">
                      {locations.map((name, index) => (
                        <div key={index} className={`item ${selected === name ? "selected" : ""}`}
                          onClick={() => { setSelected(name); setOpen(false); }} > {name}
                        </div>
                      ))}
                    </div>
                  )}
                </div>
              </div>
            </div>
            <div className="blog-post">
              <div className="row">
                {displayData?.map((item, index) => (
                  <div className="col-md-6" key={index}>
                    <div className="blog-post-wrapper">
                      <Link to={`/blog/${item?.slug}`} className="blog-post-col">
                        <div className="image-sec">
                          <img src={getMediaUrl(item?.thumbnail)} className="img-responsive" alt={item?.alt_thumbnail} loading="lazy" />
                        </div>
                        <div className="content-sec">
                          <div className="date-wrapper">
                            <span className="date-text">{DateConvert(item?.date)} </span>
                            <span className="space">|</span>
                            <span className="min-text">  by {item?.author_name}  </span>
                          </div>
                          {/* <h2 className="heading">{item?.title?.slice(0, 220) + "..."}  </h2> */}
                          <h2 className="heading">{truncateWords(item?.title, 14)}</h2>
                          <div className="arrow-butn"> Read More <img src="/image/right-arrow.svg" alt="arrow" /> </div>
                        </div>
                      </Link>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}